module.exports = __webpack_public_path__ + "static/img/car_6_8_cold@3x.48e90251.png";